import { render, staticRenderFns } from "./SecondChanceWinners.vue?vue&type=template&id=2f43de7b&scoped=true"
import script from "./SecondChanceWinners.vue?vue&type=script&lang=js"
export * from "./SecondChanceWinners.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f43de7b",
  null
  
)

export default component.exports